import type { ModuleTagEntry } from './index';

/** Cine module tags. */
export const tags: ModuleTagEntry[] = [
  'FrameTime',
  'RecommendedDisplayFrameRate',
];
